import { dataCaretLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCaretLeft = /*#__PURE__*/createIcon(dataCaretLeft)
export default IconCaretLeft
